import { render, staticRenderFns } from "./CoozzyThumbIcon.vue?vue&type=template&id=414920fc&scoped=true"
import script from "./CoozzyThumbIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyThumbIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyThumbIcon.vue?vue&type=style&index=0&id=414920fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414920fc",
  null
  
)

export default component.exports